<div class="dialog-archive-or-unarchive-user">
  <span class="dialog-archive-or-unarchive-user__title">
    <ng-container *ngIf="isArchived">{{ 'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.TITLE' | translate }}</ng-container>
    <ng-container *ngIf="!isArchived">{{
      'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.TITLE' | translate
    }}</ng-container>
  </span>
  <span class="dialog-archive-or-unarchive-user__description">
    <ng-container *ngIf="isArchived">{{
      'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.DESCRIPTION' | translate
    }}</ng-container>
    <ng-container *ngIf="!isArchived">{{
      'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.DESCRIPTION' | translate
    }}</ng-container>
  </span>
  <div class="dialog-archive-or-unarchive-user__buttons">
    <button (click)="archiveOrUnarchiveUser()" class="dialog-archive-or-unarchive-user__buttons__button--yes">
      {{ 'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.BUTTONS.YES' | translate }}
    </button>
    <button (click)="closeDialog()" class="dialog-archive-or-unarchive-user__buttons__button--no">
      {{ 'ARCHIVE_OR_UNARCHIVE_USER_DIALOG.BUTTONS.NO' | translate }}
    </button>
  </div>
</div>
